import { InvoiceItem } from '../../../../models/invoice-item';
import { ItemsArrayHelper } from '../components/detail-positions-table-container';

export const getLastPosition = (helper: ItemsArrayHelper) => {
    return Math.max(0, ...(helper.form.values.allItems as InvoiceItem[]).map(item => item.position));
};
